module.exports = __webpack_public_path__ + "img/imagen3.86a103ca.png";